export const formatGpu = (value) => value || 'N/A';
